import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { lookupAppointmentSchema, type LookupAppointmentFormData } from '@geely/shared';
import type { Appointment } from '@geely/shared';
import {
  Alert,
  AlertDescription,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Input,
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@geely/ui';
import { AlertCircle } from 'lucide-react';

interface LookupSearchFormProps {
  searchedId: string | null;
  isLoading: boolean;
  foundAppointment: Appointment | undefined;
  onSearch: (data: LookupAppointmentFormData) => void;
}

export function LookupSearchForm({ searchedId, isLoading, foundAppointment, onSearch }: LookupSearchFormProps) {
  const lookupForm = useForm<LookupAppointmentFormData>({
    resolver: zodResolver(lookupAppointmentSchema),
    defaultValues: { appointmentId: '' },
  });

  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle>Buscar Agendamento</CardTitle>
        <CardDescription>
          Informe o ID que você recebeu ao fazer o agendamento
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Form {...lookupForm}>
          <form onSubmit={lookupForm.handleSubmit(onSearch)} className="space-y-4">
            {searchedId && !isLoading && !foundAppointment && (
              <Alert variant="destructive">
                <AlertCircle className="size-4" />
                <AlertDescription>
                  Agendamento não encontrado. Verifique o ID e tente novamente.
                </AlertDescription>
              </Alert>
            )}

            <FormField
              control={lookupForm.control}
              name="appointmentId"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>ID do Agendamento</FormLabel>
                  <FormControl>
                    <Input
                      {...field}
                      placeholder="Ex: xxxxxxxx-xxxx-4xxx-xxxx-xxxxxxxxxxxx"
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <Button type="submit" className="w-full" disabled={isLoading}>
              {isLoading ? 'Buscando...' : 'Buscar'}
            </Button>
          </form>
        </Form>
      </CardContent>
    </Card>
  );
}
